//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React, { useState } from 'react';

import DefaultModal from '@components/DefaultModal';
import ActionButton from '@components/atoms/action-button/ActionButton';
import { SmallTooltip } from '@components/molecules/tooltip/Tooltip';
import { ContentDrawerTrackingIds } from '@content-drawer/contentDrawerConstants';
import { ManageLabelsTable } from '@content-drawer/filters/labels/ManageLabelsTable';
import { isDefined } from '@utils/filterPredicates';

interface ManageLabelsDialogProps {
  onToggleModal?: (isOpen: boolean) => void;
  shouldHideOverlay?: boolean;
}

export const ManageLabelsDialog = ({
  onToggleModal,
  shouldHideOverlay,
}: ManageLabelsDialogProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const onChangeModalOpenState = (isOpen: boolean) => {
    setIsOpen(isOpen);
    if (isDefined(onToggleModal)) {
      onToggleModal(isOpen);
    }
  };

  return (
    <>
      <SmallTooltip
        content='Manage Labels'
        interactive={false}
        placement='right'
        target={
          <ActionButton
            iconName='settings'
            onClick={() => onChangeModalOpenState(true)}
            trackingId={ContentDrawerTrackingIds.OPEN_MANAGE_LABELS_MODAL}
          />
        }
      />

      <DefaultModal
        closeModal={() => onChangeModalOpenState(false)}
        contents={<ManageLabelsTable />}
        isModalOpen={isOpen}
        primaryButtonInfo={{
          buttonContent: 'Done',
          onClick: () => onChangeModalOpenState(false),
          trackingId: ContentDrawerTrackingIds.CLOSE_MANAGE_LABELS_MODAL,
        }}
        shouldHideOverlay={shouldHideOverlay}
        shouldIncludeSecondaryButton={false}
        title='Manage Labels'
        width='wide'
      />
    </>
  );
};
